import React, { useEffect, Suspense } from 'react';
import { Route, Routes } from 'react-router';
import EmsLogin from '../Login/EmsLogin';
import CompanyLogin from '../Login/CompanyLogin';
import CandidateLogin from '../Login/CandidateLogin';
import AnonymousCmpRegistration from '../EMSModule/Company/AnonymousCmpRegistration';
import routeConfig from './RouteConfig';
import LandingPage from '../Website/LandingPage';
import PricingPage from '../Website/PricingPage';
import PrivacyPolicy from '../Website/PrivacyPolicy';
import Reset from '../LayOut/Reset';
import ForgotPassword from '../Login/ForgotPassword';
import ForbiddenPage from './ForbiddenPage';
import ProtectedRoute from './ProtectedRoute';

const flattenRoutes = (routes) => {
  const flatRoutes = [];
  const recurse = (items) => {
    items.forEach((route) => {
      if (route.path && route.element) {
        flatRoutes.push(route);
      }
      if (route.children && Array.isArray(route.children)) {
        recurse(route.children);
      }
    });
  };
  recurse(routes);
  return flatRoutes;
};

const Routing = () => {
  const allRoutes = flattenRoutes(routeConfig);

  return (
    <Suspense
      fallback={
        <div className="d-flex justify-content-center align-items-center vh-100">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      }
    >
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path='/:company/candidateLogin' element={<CandidateLogin />} />
        <Route path='/admin' element={<EmsLogin />} />
        <Route path='/:company/login' element={<CompanyLogin />} />
        <Route path='/resetPassword' element={<Reset />} />
        <Route path='/forgotPassword' element={<ForgotPassword />} />
        <Route path="/:company/forgotPassword" element={<ForgotPassword />} />
        <Route path='/anonymouseCmpRegistration' element={<AnonymousCmpRegistration />} />
        <Route path='/forbidden' element={<ForbiddenPage />} />
        {allRoutes.map(({ path, element, allowedRoles, allowedResourceTypes, redirectResourceTypes }, index) => (
          <Route
            key={index}
            path={path}
            element={
              <ProtectedRoute
                element={element}
                allowedRoles={allowedRoles}
                allowedResourceTypes={allowedResourceTypes}
                redirectResourceTypes={redirectResourceTypes}
              />
            }
          />
        ))}
      </Routes>
    </Suspense>
  );
};
export default Routing;
